import { ActivityStatus } from './activity-status.model';
import { DevicePlacement } from './device-placement.model';
import { BidderConfig } from './bidder-config.model';
import { Publisher } from './publisher.model';
import { Domain } from './domain.model';
import { ContractRelationship } from './contract-relationship.enum';
import { DomainDpApproval } from './domain-dp-approval.model';
import { BridgeAdUnitDpHbId } from './bridge-ad-unit-hb-id.model';
import { AdConfig } from '../../kitchen/shared/domain/ad-config.model';
import { KeyLabel } from './key-label.model';
import { UnitWrapperType } from './unit-wrapper-type.enum';
import { WidgetType } from './widget-type.model';

export class BridgeAdUnit {
  id: string;
  name: string;
  customName: string;
  campaignId: string;
  widgetName: string;
  publisher: Publisher;
  publisherId: string;
  domain: Domain;
  domainIds: string[];
  domains: Domain[];
  devicePlacement: DevicePlacement;
  domainDpApprovals: DomainDpApproval[];
  demandPartnerHbIds: BridgeAdUnitDpHbId[];
  activityStatus: ActivityStatus;
  ron: boolean;
  unitCreateAdstxtOverride: boolean;
  ebAssociatedPublisherId: string;
  ebChannel: string;
  companionAdUnitId: string;
  unitBuildPending: boolean;
  contractRelationship: ContractRelationship;
  adConfig: AdConfig;

  healthy: boolean;
  videoUnit: boolean;
  flag: boolean;
  healthyChangedOn: string;
  postHealthCheck: boolean;
  postHealthCheckDate: string;
  bidderCalc: boolean;
  bidderCalcDate: string;

  bidIncrement: number;
  currentBidIncrement: number;
  currentBidValue: number;
  revenueShare: number;
  currentRevshare: number;
  currentBidderRevshare: number;
  currentIoCpm: number;
  createdOn: number;
  lastUpdatedOn: number;
  test: boolean;
  fromPublisherRequest: boolean;
  createPixelUnit: boolean;
  taxonomy: string;
  feedUrl: string;
  feedType: FeedType;
  springServeVideoId: string;
  breakoutFromIframe: boolean;
  ctvEmbed?: boolean;
  ctvEmbedId?: string;
  enabled: boolean;
  position: string;

  //bidder
  unitWrapperType: UnitWrapperType;
  bidder: boolean;
  s2s: boolean;
  bidderDp: string;
  bidderConfig: BidderConfig;

  //tags
  adUnitTag: string;
  vastTag: string;
  pixelTag: string;

  //dfp
  gptTag: string;
  gptDiv: string;
  hasPendingUpdateEmails: boolean;
  waitsToBeActive: boolean;
  dfpPixelUnit: string;
  dfpAdUnitId: number;
  dfpParentAdUnitId: string;
  dfpAdUnitName: string;
  dfpAdUnitSizes: string;
  dfpAdUnitCode: number;
  dfpPlacementName: string;
  serverbid: boolean;
  readyUnitEmailSentAt: number;
  hasAllCondensedAdsTxtRecords: string;
  ebAssociatedPublisher: Publisher;

  siteApprovals: SiteApprovals;
  unitApprovals: UnitApprovals;

  _domainUrls: string[];
  _domainsApproved: number;
  _domainsDpsApproved: number;
  ext_companionAdUnitName: string;
  cxHash: string;
}

export enum FeedType {
  DEEZER = 'DEEZER',
  DASH = 'DASH',
  PODCAST = 'PODCAST',
  N_A = 'N_A',
  RECIPE = 'RECIPE',
  CUSTOM = 'CUSTOM'
}

export const FeedTypeKL = () => {
  return Object.keys(FeedType).map(key => new KeyLabel(key, FeedType[key]));
};


export class SiteApprovals {
  siteDpApprovals: { string: DomainDpApproval[] };
  okSites: number;
  nokSites: number;
  sites: number;
}

export class UnitApprovals {
  okDps: number;
  nokDps: number;
  dps: number;
  _rejected: number;
  _approved: number;
  _notAvailable: number;
  _pending: number;
}
